import React, { CSSProperties } from "react";
import * as styles from "./popup-sheet-header.module.scss";
import { classArr } from "../../helper/style-helper";
import IconClose from "../../dynamicicons/icon-close";
import VelavuIconButton from "../../elements/velavu-icon-button";
import whitelabel from "../../whitelabel";

export interface PopupSheetHeaderProps {
	style?: CSSProperties;
	className?: string;
	title: string;
	onClose?: () => void;
}

export default function PopupSheetHeader(props: PopupSheetHeaderProps) {
	return (
		<div
			style={props.style}
			className={classArr(props.className, styles.container)}
		>
			<span className={styles.title}>{props.title}</span>

			<VelavuIconButton onClick={props.onClose}>
				<IconClose color={whitelabel.palette.secondary500} />
			</VelavuIconButton>
		</div>
	);
}
